






























































































































import { defineComponent, toRefs, PropType, computed, ref, watch } from '@vue/composition-api';
import { IdentityFullInfo } from '../types';
import { IDENTITY_TYPE_MAP } from '@tt4b/ttam-enums';
import { useIdentityDisplayList } from './hooks';
import { BCDomain } from '../hooks';
import UnbindIcon from '@tt4b/ttam-assets/src/svgs/creative/use-account-change-bind-icon.svg';
import { debounce } from 'lodash-es';
import { trackEvent } from './../../../utils/index';

const { BC_AUTH_TT } = IDENTITY_TYPE_MAP;
const name = 'ttam-affiliate-identity-select-popover';
export default defineComponent({
  name,
  components: {
    UnbindIcon,
  },
  props: {
    dataSource: {
      type: Array as PropType<IdentityFullInfo[]>,
      default: () => [],
    },
    curIdentityInfo: {
      type: Object as PropType<IdentityFullInfo>,
      default: () => ({}),
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    identitySelectPopoverVisible: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { dataSource, curIdentityInfo } = toRefs(props);
    const { keywords, identityDisplayList, unAvailableIdentityDisplayList, isShowTtbaAddBtn } = useIdentityDisplayList({
      dataSource,
    });
    const getIdentityVal = (_curIdentityInfo: IdentityFullInfo = {} as IdentityFullInfo) => {
      if (_curIdentityInfo.identityType === BC_AUTH_TT) {
        return `${_curIdentityInfo.identityId}_${_curIdentityInfo.identityBcId}`;
      }
      return `${_curIdentityInfo.identityId}_${_curIdentityInfo.identityType}`;
    };
    const identityValue = computed(() => getIdentityVal(curIdentityInfo.value));

    const handleIdentityChange = (identityVal: IdentityFullInfo) => {
      emit('identity-change', identityVal);
    };
    const handleIdentityListRefresh = () => {
      emit('refresh');
    };
    const onUnLink = (e: Event) => {
      e.preventDefault(); // 停止冒泡
      emit('unlink');
    };
    const handleAccountAdd = () => {
      emit('account-add');
    };
    const onPopoverCTAItem = (identityInfo: IdentityFullInfo = {} as IdentityFullInfo) => {
      trackEvent('ad_start_with_product_authorize_account_get_permission', {
        identityType: identityInfo.identityType,
      });
    };
    const handleIdentityKeywordsChange = debounce((val: string) => {
      keywords.value = val;
      trackEvent('ad_start_with_product_menu_search_identity', { value: val });
    }, 1000);
    return {
      name,
      BCDomain,
      IDENTITY_TYPE_MAP,
      keywords,
      identityValue,
      identityDisplayList,
      unAvailableIdentityDisplayList,
      isShowTtbaAddBtn,
      handleIdentityChange,
      getIdentityVal,
      handleIdentityListRefresh,
      handleAccountAdd,
      onUnLink,
      onPopoverCTAItem,
      handleIdentityKeywordsChange,
    };
  },
});
